import { fetchFooter } from "@/src/api";
import Link from "next/link";
import Image from "next/image";
import { FooterSection } from "@/src/api/fetchFooter/types";

export default async function Footer() {
  const footerData: FooterSection[] = await fetchFooter();
  const footer = footerData[0];
  return (
    <footer className="footer-container px-2 sm:px-4 lg:px-8 py-4 sm:py-8 lg:py-12">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
        {footer?.acf?.about_central && (
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={footer.acf.about_central.url}
            className="group text-xs sm:text-sm text-gray-600 font-semibold relative inline-block transition-colors duration-300"
          >
            <span className="underline-animation"></span>
            {footer.acf.about_central.title}
          </Link>
        )}

        <div className="text-black">
          {footer?.acf?.ecoshop_logo &&
          typeof footer.acf.ecoshop_logo === "object" &&
          footer.acf.ecoshop_logo.url ? (
            <Image
              src={footer.acf.ecoshop_logo.url}
              alt="Ecoshop Logo"
              width={200}
              height={40}
              className="object-contain"
            />
          ) : (
            <span className="text-sm sm:text-base">ECOSHOP LOGO</span>
          )}
        </div>

        {footer?.acf?.privacy_policy && (
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={footer.acf.privacy_policy.url}
            className="group text-xs sm:text-sm text-gray-600 font-semibold relative inline-block transition-colors duration-300"
          >
            <span className="underline-animation"></span>
            {footer.acf.privacy_policy.title}
          </Link>
        )}
      </div>

      <hr className="mt-4 sm:mt-6 lg:mt-10 border-gray-300" />
      <div>
        <p className="text-xs text-gray-500 mt-4 sm:mt-6 lg:mt-10 text-center">
          © {new Date().getFullYear()} The Central Group of Companies
        </p>
      </div>
    </footer>
  );
}
